import "url-polyfill"
import fetch from "cross-fetch"
import globals from "@/utils/globals"
import { redirectToCloudflareCaptchaOnError } from "@/utils/cloudflare-xhr-captcha-handler"

const defaultOptions = {
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Accept": "application/json, */*"
  }
}

const request = (path, opts = {}) => {
  let options = mergeDefaultOptions(opts)
  let url = new URL(path, document.location.origin)

  if (options.params) {
    const searchParams = new URLSearchParams()
    Object.keys(options.params).forEach((key) => searchParams.set(key, options.params[key]))
    url.search = searchParams.toString()
    delete options.params
  }

  // By default assume that we want to send JSON data when passing in an object for the body
  if (options.body instanceof Object && !(options.body instanceof FormData)) {
    options.body = JSON.stringify(options.body)
    options.headers["Content-Type"] = "application/json"
  }

  if (options.token) {
    options = setToken(options)
  }

  if (options.ajax === false) {
    options = removeAjax(options)
  }

  return fetch(url.toString(), options)
    .then(redirectToCloudflareCaptchaOnError)
    .then((response) => {
      const contentType = response.headers.get("Content-Type") || ""
      if (contentType.indexOf("application/json") >= 0) {
        return Promise.all([response, response.json()])
      } else {
        return Promise.all([response, response.text()])
      }
    })
    .then(([response, content]) => {
      if (!response.ok) {
        const error = new Error()
        error.name = response.status
        error.message = response.statusText
        error.content = content
        throw error
      } else {
        return content
      }
    })
}

const get = (path, options = {}) => {
  return request(path.toString(), options)
}

const post = (path, options = {}) => {
  options.method = "POST"

  return request(path, options)
}

const put = (path, options = {}) => {
  options.method = "PUT"

  return request(path, options)
}

const patch = (path, options = {}) => {
  options.method = "PATCH"

  return request(path, options)
}

const del = (path, options = {}) => {
  options.method = "DELETE"

  return request(path, options)
}

const mergeDefaultOptions = (opts) => {
  return {
    ...defaultOptions,
    ...opts,
    headers: {
      ...defaultOptions.headers,
      ...opts.headers
    }
  }
}

const setToken = (opts) => {
  const options = { ...opts }
  let token = globals.token
  if (!token) {
    token = document.querySelector("meta[name=csrf-token]").getAttribute("content")
  }
  options.headers = {
    ...options.headers,
    "X-CSRF-TOKEN": token
  }
  delete options.token
  return options
}

/* Remove ajax header for, for example, other domain get requests */
const removeAjax = (opts) => {
  const options = { ...opts }
  delete options.headers["X-Requested-With"]
  return options
}

export default {
  get,
  post,
  put,
  patch,
  delete: del
}
